import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {NearWinReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {TractorBeamBackground} from "./background/TractorBeamBackground";
import {TractorBeamAddFreespinController} from "./freespin/TractorBeamAddFreespinController";
import {TractorBeamIntroView} from "./intro/TractorBeamIntroView";
import {TractorBeamRandomFeatureController} from "./randomfeature/TractorBeamRandomFeatureController";
import {TractorBeamRandomFeatureView} from "./randomfeature/TractorBeamRandomFeatureView";
import {TractorBeamSpinController} from "./randomstackfeature/spin/TractorBeamSpinController";
import {TractorBeamBeforeSpinStopController} from "./randomstackfeature/TractorBeamBeforeSpinStopController";
import {TractorBeamRandomStacks} from "./randomstackfeature/TractorBeamRandomStacks";
import {SpineReelPartCreator} from "./reel/SpineReelPartCreator";
import {TractorBeamReelController} from "./reel/TractorBeamReelController";
import {TractorBeamReelAreaView} from "./reelarea/TractorBeamReelAreaView";
import {TractorBeamReels} from "./reelarea/TractorBeamReels";
import {TractorBeamReelAttentionController} from "./reelstoppresentation/reelattention/TractorBeamReelAttentionController";
import {TractorBeamScatterAttentionController} from "./reelstoppresentation/scatterattention/TractorBeamScatterAttentionController";
import {TractorBeamReelStopPresentation} from "./reelstoppresentation/TractorBeamReelStopPresentation";
import {TractorBeamScatterReelSymbol} from "./reelsymbol/TractorBeamScatterReelSymbol";
import {TractorBeamFreeSpinIntroController} from "./screen/freeSpinIntro/TractorBeamFreeSpinIntroController";
import {TractorBeamFreeSpinIntroScreenView} from "./screen/freeSpinIntro/TractorBeamFreeSpinIntroScreenView";
import {TractorBeamFreeSpinOutroController} from "./screen/freeSpinOutro/TractorBeamFreeSpinOutroController";
import {TractorBeamFreeSpinOutroView} from "./screen/freeSpinOutro/TractorBeamFreeSpinOutroView";
import {TractorBeamParsedGameData} from "./server/data/TractorBeamParsedGameData";
import {TractorBeamParsedInitData} from "./server/data/TractorBeamParsedInitData";
import {TractorBeamServerDataParser} from "./server/TractorBeamServerDataParser";
import {SoundPlayer} from "./soundplayer/SoundPlayer";
import {BasicStateReelSymbol} from "./symbols/BasicStateReelSymbol";
import {TractorBeamFontConfig} from "./TractorBeamFontConfig";
import {TractorBeamGameAssets} from "./TractorBeamGameAssets";
import {TractorBeamGameConfig} from "./TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "./TractorBeamSoundConfig";
import {AnimatedWinLinesController} from "./winpresentation/animatedwinlines/AnimatedWinLinesController";
import {TractorBeamBigWinController} from "./winpresentation/bigwin/TractorBeamBigWinController";
import {TractorBeamBetLineIndividualWPController} from "./winpresentation/individualWin/TractorBeamBetLineIndividualWPController";
import {TractorBeamBetLines} from "./winpresentation/TractorBeamBetLines";
import {TractorBeamCommandCenterView} from "./winpresentation/TractorBeamCommandCenterView";
import {TractorBeamInitialWinPresentationController} from "./winpresentation/TractorBeamInitialWinPresentationController";
import {IndiSymWinHighlightPresentation} from "./winpresentation/IndiSymWinHighlightPresentation";

export class TractorBeamGameModuleConfig implements IGameModuleConfig {

    public static instance:TractorBeamGameModuleConfig = new TractorBeamGameModuleConfig();

    private static gameTweakerTest:GameTweakerTest;
    private static reelDivider:NearWinReelDivider;
    private static betLinesView:BetLinesView;
    private static betLines:TractorBeamBetLines;

    public static tractorBeamRandomFeatureController:TractorBeamRandomFeatureController;
    public static tractorBeamRandomFeatureView:TractorBeamRandomFeatureView;
    public static tractorBeamCommandCenterView:TractorBeamCommandCenterView;
    public static tractorBeamRandomStacks:TractorBeamRandomStacks;
    public static background:TractorBeamBackground;
    //public static particleController:ParticleController;
    public static animatedWinLinesController:AnimatedWinLinesController;
    public static soundPlayer:SoundPlayer;
    public static reelAttention:TractorBeamReelAttentionController;
    public static reelController:TractorBeamReelController;

    GAME_CONFIG:IGameConfig = TractorBeamGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = TractorBeamSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = TractorBeamFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = TractorBeamGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new TractorBeamServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new TractorBeamParsedInitData(data, <TractorBeamServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new TractorBeamParsedGameData(data, <TractorBeamServerDataParser>dataParser);

    REEL_AREA_VIEW:() => ReelAreaView = () => new TractorBeamReelAreaView([
        [0, this.GAME_CONFIG.REEL_AREA_POS_Y],
        [this.GAME_CONFIG.SYMBOL_WIDTH, this.GAME_CONFIG.REEL_AREA_POS_Y],
        [this.GAME_CONFIG.SYMBOL_WIDTH * 2, this.GAME_CONFIG.REEL_AREA_POS_Y],
        [this.GAME_CONFIG.SYMBOL_WIDTH * 3, this.GAME_CONFIG.REEL_AREA_POS_Y],
        [this.GAME_CONFIG.SYMBOL_WIDTH * 4, this.GAME_CONFIG.REEL_AREA_POS_Y]
    ]);
    REELS:() => Reels = () => new TractorBeamReels();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => {
        const tbrc:TractorBeamReelController = new TractorBeamReelController(reelId);
        TractorBeamGameModuleConfig.reelController = tbrc;
        return tbrc;
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => new SpineReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):BasicStateReelSymbol => {
            if(symName === ReelSymbolName.SCATTER) {
                return new TractorBeamScatterReelSymbol(symName, reelId, state);
            }

            // TODO: Super f0gly, find out WTF is going on, HINT: FS RESTORE, sym name is undefined
            if(!symName) {
                return new BasicStateReelSymbol("W", reelId, state);
            } else {
                return new BasicStateReelSymbol(symName, reelId, state);
            }
        });

    INTRO_VIEW:(onClickCallback:() => void) => TractorBeamIntroView =
        (onClickCallback:() => void) => new TractorBeamIntroView({
            layer : this.GAME_CONFIG.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : TractorBeamGameAssets.INTRO_BACKGROUND},
            },
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_EXTREME]
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    SCREENS:(() => ScreenController)[] = [
        () => new TractorBeamFreeSpinIntroController({
            viewCreator : (onContinueButtonClickCallback:() => void, autoClose?:boolean) => new TractorBeamFreeSpinIntroScreenView({
                layer : this.GAME_CONFIG.LAYERS.FS_SCREEN.name,
                onButtonClickCallback : onContinueButtonClickCallback,
                buttonBackgroundConfig : {
                    cornerRadius : 12,
                    lineThickness : 2,
                    lineColor : 0xffffff,
                    lineAlpha : 1,
                    backgroundColor : 0x000000,
                    backgroundAlpha : 0.4
                },
                mobileScale : 1.2,
                portraitScale : 1.2
            }, autoClose)
        }),
        () => new TractorBeamFreeSpinOutroController({
            viewCreator : (onContinueButtonClickCallback:() => void, autoClose?:boolean) => new TractorBeamFreeSpinOutroView({
                layer : this.GAME_CONFIG.LAYERS.FS_SCREEN.name,
                onButtonClickCallback : onContinueButtonClickCallback,
                buttonBackgroundConfig : {
                    cornerRadius : 12,
                    lineThickness : 2,
                    lineColor : 0xffffff,
                    lineAlpha : 1,
                    backgroundColor : 0x000000,
                    backgroundAlpha : 0.4
                },
                mobileScale : 1.2,
                portraitScale : 1.2
            }, autoClose)
        })
    ];

    SPIN_CONTROLLER:() => TractorBeamSpinController = () => new TractorBeamSpinController();

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController()
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS:((index:number) => BeforeSpinStopPresentationController)[] = [
        index => new TractorBeamBeforeSpinStopController(index)
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new TractorBeamScatterAttentionController(index, {
            numOfScattersToWin : 3,
            scattersMap : [true, true, true, true, true]
        }),
        index => {
            const rac:TractorBeamReelAttentionController = <TractorBeamReelAttentionController>new TractorBeamReelAttentionController(index);
            TractorBeamGameModuleConfig.reelAttention = rac;

            return rac;
        },
        index => new TractorBeamReelStopPresentation(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IndiSymWinHighlightPresentation(indexes)],
        [indexes => new TractorBeamBigWinController(indexes)],
        [indexes => new TractorBeamInitialWinPresentationController(indexes)],
        [indexes => new TractorBeamAddFreespinController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new TractorBeamBetLineIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0.6;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        TractorBeamGameModuleConfig.gameTweakerTest = new GameTweakerTest();

        TractorBeamGameModuleConfig.background = new TractorBeamBackground({
            layer : this.GAME_CONFIG.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : TractorBeamGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(0, -500)},
                FREESPIN : {image : TractorBeamGameAssets.FS_BACKGROUND, offset : new PIXI.Point(0, -400)}
            },
            positions : [ // TODO: positions need to be handled in portrait as well.
                [230, 70],
                [230 + this.GAME_CONFIG.SYMBOL_WIDTH, 70],
                [230 + this.GAME_CONFIG.SYMBOL_WIDTH * 2, 70],
                [230 + this.GAME_CONFIG.SYMBOL_WIDTH * 3, 70],
                [230 + this.GAME_CONFIG.SYMBOL_WIDTH * 4, 70]
            ],
            stretch : false
        });

        TractorBeamGameModuleConfig.tractorBeamRandomFeatureController = new TractorBeamRandomFeatureController();
        TractorBeamGameModuleConfig.tractorBeamRandomFeatureView = new TractorBeamRandomFeatureView(ResourcesGroupName.MAIN);
        TractorBeamGameModuleConfig.tractorBeamCommandCenterView = new TractorBeamCommandCenterView(ResourcesGroupName.MAIN);
        TractorBeamGameModuleConfig.betLines = new TractorBeamBetLines();
        TractorBeamGameModuleConfig.tractorBeamRandomStacks = new TractorBeamRandomStacks();
        //TractorBeamGameModuleConfig.particleController = new ParticleController();
        TractorBeamGameModuleConfig.animatedWinLinesController = new AnimatedWinLinesController();
        TractorBeamGameModuleConfig.soundPlayer = new SoundPlayer();
        //TractorBeamGameModuleConfig.beforeSpinStop = <TractorBeamBeforeSpinStopController> (this.BEFORE_SPIN_STOP_PRESENTATIONS[0]);

        //Commented as reel display is not shown in mockup

        // TractorBeam.betLinesView = new BetLinesView(
        //     {
        //         map : [
        //             4, 2, 1, 3, 5, // left
        //             10, 8, 6, 7, 9// right
        //         ]
        //     },
        //     (index:number):TextBetLineNumber => {
        //         return new TextBetLineNumber(index, {
        //             layer : GameConfig.instance.LAYERS.BET_LINES.name,
        //             width : 40,
        //             height : 40,
        //             horizontalPadding : GameConfig.instance.REEL_AREA_POS_X - 25,
        //             verticalPadding : [
        //                 GameConfig.instance.REEL_AREA_POS_Y + 40,
        //                 (GameConfig.instance.GAME_HEIGHT - (GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.REEL_AREA_HEIGHT)) + 40
        //             ],
        //             textStyleNormal : {
        //                 fontFamily : "Open Sans",
        //                 fontSize : 20,
        //                 fill : "#a6759a"
        //             },
        //             textStyleWin : {
        //                 fontFamily : "Open Sans",
        //                 fontSize : 30,
        //                 fill : "#ffffff",
        //                 stroke : "#dfb8cd",
        //                 strokeThickness : 2,
        //                 padding : 4
        //
        //             },
        //             textWinScale : 1
        //         });
        //     },
        //     (index:number, numberPosition:number[], betLineData:number[]):PolyBetLine => {
        //         return new PolyBetLine(index, numberPosition, betLineData, {
        //             staticLineLayer : GameConfig.instance.LAYERS.BET_LINES.name,
        //             styles : [
        //                 {
        //                     "lineWidth" : 3,
        //                     "color" : 0xffffff,
        //                     "alpha" : 1
        //                 },
        //                 {
        //                     "lineWidth" : 1,
        //                     "color" : 0xdfb8cd,
        //                     "alpha" : 1
        //                 }
        //             ],
        //             numberOffsetX : 20,
        //             pointOverlapVerticalOffset : 8
        //         });
        //     }
        // );
        StageManager.legacyScaling = true;
    };

    constructor() {
        if(TractorBeamGameModuleConfig.instance) {
            throw new Error("TractorBeamGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}
